<template>
  <div>
    <v-toolbar :color="statusColor(goal.status)" height="80">
      <div>
        <v-toolbar-title v-if="goal.status && goal.status.toLowerCase() == 'in progress' && goal.dueDate"
          >Due {{ formatDateFromNow(goal.dueDate) }}
        </v-toolbar-title>
        <div v-if="goal.createdAt" style="font-size: 12px;">Created: {{ goal.createdAt }}</div>
        <div v-if="goal.dueDate" style="font-size: 12px;">Due: {{ goal.dueDate }}</div>
        <div v-if="goal.achievedAt" style="font-size: 12px;">Achieved: {{ goal.achievedAt }}</div>
      </div>
      <v-spacer></v-spacer>
      <span class="overline">
        <strong>
          {{ goal.status }}
        </strong>
      </span>
    </v-toolbar>

    <v-card-text> {{ goal.ultimateWhy }} </v-card-text>
    <v-card-actions v-if="editable">
      <v-spacer />
      <v-btn class="mx-2 mb-2" fab dark x-small color="secondary" @click="editGoal()">
        <v-icon dark> mdi-pencil </v-icon>
      </v-btn>
      <v-btn class="ml-4 mb-2" fab dark x-small color="red" @click="deleteGoal()">
        <v-icon dark> mdi-trash-can-outline </v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import GoalsBase from "./GoalsBase";

export default {
  name: "Goal",
  props: ["goal", "editable"],
  mixins: [GoalsBase],
  data() {
    return {};
  },
  methods: {
    formatDateFromNow(date) {
      date = this.$moment(date);
      return `${date.fromNow()}`;
    },
    formatShortDate(date) {
      return `${this.$moment(date).format("DD-MM-YYYY")}`;
    },
    editGoal() {
      this.$emit("edit");
    },
    deleteGoal() {
      if (window.confirm("Are you sure you want to delete this goal? This cannot be undone.")) {
        this.$emit("delete");
      }
    },
    hasTextUnit() {
      return this.goal.goalMeasurement.some((measurement) => measurement.targetText != null);
    },
    hasValueUnits() {
      return this.goal.goalMeasurement.some(
        (measurement) => measurement.initialValue != null || measurement.targetValue != null
      );
    },
  },
};
</script>
